export default ['api', '$rootScope', function(api, $rootScope) {
    return {
        toJson: data => {
            if ( data.sections ) {
                let newSections = {};
                for ( let section of data.sections ) {
                    newSections[section.section] = {};
                    if ( section.elements ) {
                        for ( let element of section.elements ) {
                            if ( element.type === 'image' ) {
                                newSections[section.section][element.element] = {'image_url': element.value };
                            } else {
                                newSections[section.section][element.element] = element.value;
                            }
                        }
                    }
                }
                data.sections = newSections;
                data.id = null;
            }

            return data;
        },

        fromJson: data => {
            if ( data.sections ) {
                for ( let sectionKey in data.sections ) {
                    for ( let elementKey in data.sections[sectionKey] ) {
                        if (data.sections[sectionKey][elementKey] && data.sections[sectionKey][elementKey].type_raw) {
                            data.sections[sectionKey][elementKey] = data.sections[sectionKey][elementKey].type_raw + '|' + data.sections[sectionKey][elementKey].id;
                        }
                    }
                }
            }

            return data;
        }
    };
}];


// WEBPACK FOOTER //
// ./frontend/admin/app/modules/pageContent/services/pageContent.transformer.service.js